export default __webpack_public_path__ + "static/65285941-0-cash-game-challenge--296a5dd5898312dca79cbaf5fd92bb07.webp";